import { useState } from "react";
import {
  proofFileName,
  saveBlobAs,
} from "src/business/payment/proofDownload";
import { resolvePaymentErrorKey } from "src/business/payment/paymentErrors";

type ProofFetcher = () => Promise<{ blob: Blob; contentType: string | null }>;

/**
 * Download state for a list of proofs: which row is in flight, and the i18n key
 * of the last failure. Shared by the restaurateur's page and the admin queue,
 * which differ only in the endpoint their fetcher calls.
 */
export const useProofDownload = () => {
  const [downloadingId, setDownloadingId] = useState<string | null>(null);
  const [errorKey, setErrorKey] = useState<string | null>(null);

  const download = async (paymentId: string, fetchProof: ProofFetcher) => {
    setDownloadingId(paymentId);
    setErrorKey(null);
    try {
      const { blob, contentType } = await fetchProof();
      saveBlobAs(blob, proofFileName(paymentId, contentType));
    } catch (error) {
      setErrorKey(resolvePaymentErrorKey(error));
    } finally {
      setDownloadingId(null);
    }
  };

  return {
    download,
    downloadingId,
    errorKey,
    clearError: () => setErrorKey(null),
  };
};
